import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { cn } from '@divlab/divanui';
import equal from 'fast-deep-equal';

import styles from './ConstructorImage.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface ConstructorImageProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  images: string[];
}

interface ImageProps {
  image: string;
  className?: string;
}

const Image: FC<ImageProps> = (props) => {
  const { image, className, ...restProps } = props;
  const initialImage = useRef(image);
  const [loaded, setLoaded] = useState(true);

  const handleLoad = useCallback(() => {
    initialImage.current = image;
    setLoaded(true);
  }, [image]);

  useEffect(() => {
    if (equal(image, initialImage.current)) return;
    setLoaded(false);
  }, [image]);

  return (
    <div {...restProps} className={cn(styles.imageWrapper, { [styles.loaded]: loaded }, className)}>
      <img
        src={initialImage.current}
        alt=''
        className={cn(styles.image, { [styles.initial]: true })}
      />
      <img src={image} alt='' className={styles.image} onLoad={handleLoad} />
    </div>
  );
};

const ConstructorImage: FC<ConstructorImageProps> = (props) => {
  const { className, images, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {images.map((image, index) => (
        <Image image={image} key={index} />
      ))}
    </div>
  );
};

export default memo(ConstructorImage);
